import { ApolloClient, createHttpLink, from, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { getAuth0Token } from "../auth/token";
import { MessageFromAddInType, subscribeToMessageType } from "../helpers/window-events";

// error received from the API when the JWT token is expired
const JWT_TOKEN_EXPIRED_ERROR = "Received status code 401";

// to prevent multiple reloads when the token is expired
let isReloading = false;

// Subscribe to the message from the add-in for token expiration
subscribeToMessageType(
  MessageFromAddInType.TOKEN_EXPIRED,
  () => handleExpiredToken(),
);

const handleExpiredToken = () => {
  if (isReloading) {
    return;
  }
  isReloading = true;
  window.location.reload();
};

const httpLink = createHttpLink({
  uri: import.meta.env.ADMIN_API_ENDPOINT,
});


const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = getAuth0Token();
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const errorLink = onError(({ networkError }) => {
  if (networkError && networkError.message.includes(JWT_TOKEN_EXPIRED_ERROR)) {
    handleExpiredToken();
  }
});

export const apolloClient = new ApolloClient({
  link: from([errorLink, authLink.concat(httpLink)]),
  cache: new InMemoryCache(),
  connectToDevTools: false,
});
